var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#0F1CB7",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_26931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8999 28.7536L31.6732 28.5536C31.0302 27.9807 30.4673 27.3236 29.9999 26.6003C29.4894 25.602 29.1834 24.5117 29.0999 23.3936V20.1003C29.1043 18.344 28.4672 16.6466 27.3084 15.3269C26.1495 14.0072 24.5486 13.1562 22.8065 12.9336V12.0736C22.8065 11.8376 22.7128 11.6112 22.5459 11.4443C22.379 11.2774 22.1526 11.1836 21.9165 11.1836C21.6805 11.1836 21.4541 11.2774 21.2872 11.4443C21.1203 11.6112 21.0265 11.8376 21.0265 12.0736V12.9469C19.3 13.1855 17.7185 14.0418 16.5749 15.357C15.4313 16.6722 14.803 18.3574 14.8065 20.1003V23.3936C14.723 24.5117 14.4171 25.602 13.9065 26.6003C13.4471 27.3218 12.8933 27.9788 12.2599 28.5536L12.0332 28.7536V30.6336H31.8999V28.7536Z",
    fill: "#0F1CB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 31.3359C20.2714 31.7585 20.4808 32.1457 20.8024 32.4259C21.1241 32.7061 21.5363 32.8605 21.9629 32.8605C22.3895 32.8605 22.8017 32.7061 23.1234 32.4259C23.445 32.1457 23.6544 31.7585 23.7129 31.3359H20.2129Z",
    fill: "#0F1CB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_26931"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.5dd049f8968eae56e6ad0efd2b5087ee.svg";
export { ForwardRef as ReactComponent };